import { prettyPrintAndStringifyLargeNumber } from './formatNumber'

export interface MetricFormatterProps {
  unit: 'percent' | 'second' | 'compact-unit' | 'large-number' | 'number'
  shouldDisplaySign?: boolean
  maximumFractionDigits?: number
}

export function getMetricFormatter({ unit, shouldDisplaySign, maximumFractionDigits }: MetricFormatterProps) {
  switch (unit) {
    case 'percent':
      return new Intl.NumberFormat('en-US', {
        style: 'unit',
        unit: 'percent',
        maximumFractionDigits: maximumFractionDigits ?? 1,
        signDisplay: shouldDisplaySign ? 'auto' : 'never',
      })
    case 'compact-unit':
      return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 2,
        signDisplay: shouldDisplaySign ? 'auto' : 'never',
      })
    case 'second':
      return new Intl.NumberFormat('en-US', {
        style: 'unit',
        unit: 'second',
        unitDisplay: 'narrow',
        maximumFractionDigits: 2,
        signDisplay: shouldDisplaySign ? 'auto' : 'never',
      })
    case 'large-number':
      return {
        format: prettyPrintAndStringifyLargeNumber,
      }
    case 'number':
      return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: maximumFractionDigits ?? 1,
        signDisplay: shouldDisplaySign ? 'auto' : 'never',
      })
  }
}
